ScoreTrekBattle.League = ScoreTrekBattle.League || {};

ScoreTrekBattle.League.Plan = (function() {
    var _this, STATUS, CONFIG;

    CONFIG = {
        // Shared with the matchday editor: the plan list's season pre-fills the
        // editor's season field on create. Remembers the last chosen season.
        SEASON_STORAGE_KEY: 'ScoreTrekBattle.League.Matchday.Season'
    };

    function resetStatus() {
        STATUS = {
            active: false,
            loaded: false,
            view: null,
            $view: null,
            $list: null,
            seasonId: ''
        };
    }
    resetStatus();

    function onViewRender() {
        return new Promise(function(resolve) {
            ScoreTrekBattle.View.updateMenu('/league/create');
            ScoreTrekBattle.Template.renderMulti([
                'tournament/nav/tabsPlan',
                'league/plan'
            ]).then(views => {
                var $tabs;

                $tabs = views['tournament/nav/tabsPlan'].$view;
                $tabs.find('[data-tab="league"]').addClass('isActive');
                $tabs.find('[data-ref]:not([data-ref="league"])').remove();

                STATUS.active = true;
                STATUS.view = views['league/plan'];
                STATUS.$view = views['league/plan'].$view;
                STATUS.$list = STATUS.$view.find('[data-id="list"]');

                resolve($tabs.add(STATUS.$view));
            });
        });
    }

    function onViewLoad() {
        return new Promise(function(resolve) {
            STATUS.active = true;
            initSeasonSelector().then(updateList);
            resolve();
        });
    }

    // ── Season selector (top-level scope for the plan list) ──────

    function initSeasonSelector() {
        return new Promise(function(resolve) {
            var control;

            control = STATUS.view.controls.seasonId;

            Api.request('/battle/league/seasons').then(result => {
                var list, stored;

                list = result.list || [];
                control.setOptions(DataHandler.arrayToOptions(list, 'id', 'name'));

                // Restore the last chosen season if still available, else the one
                // the backend flags as current.
                stored = localStorage.getItem(CONFIG.SEASON_STORAGE_KEY) || '';
                STATUS.seasonId = list.some(season => season.id === stored)
                    ? stored
                    : (result.currentId || (list.length ? list[0].id : ''));

                control.set(STATUS.seasonId);

                control.on('change', function() {
                    STATUS.seasonId = this.get();
                    localStorage.setItem(CONFIG.SEASON_STORAGE_KEY, STATUS.seasonId);
                    updateList();
                });
            }).catch(ignore => {
            }).finally(resolve);
        });
    }

    function onViewUpdate() {
        return new Promise(function(resolve) {
            setTimeout(() => {
                if (!STATUS.$list) {
                    return;
                }
                updateList();
            }, 0);
            resolve();
        });
    }

    function onViewUnload() {
        return new Promise(function(resolve) {
            resetStatus();
            resolve();
        });
    }

    function updateList() {
        ScoreTrekBattle.View.loading('League.Plan.updateList', true);
        loadList().then(items => {
            renderList(items).then(() => {
                STATUS.loaded = true;
            });
        }).catch(error => {
            chmDialog.error(error);
        }).finally(() => {
            ScoreTrekBattle.View.loading('League.Plan.updateList', false);
        });
    }

    function loadList() {
        return new Promise(function(resolve, reject) {
            var items;

            items = [];
            STATUS.$list.addClass('loading');

            function loadPage(offset) {
                Api.request('/battle/league/matchday/plan', {offset: offset, seasonId: STATUS.seasonId || ''}).then(result => {
                    if (result.list && result.list.length > 0) {
                        items = items.concat(result.list);
                    }

                    if (result.hasMore) {
                        loadPage(items.length);
                    } else {
                        resolve(items);
                    }
                }).catch(reject);
            }

            loadPage(0);
        }).finally(() => {
            STATUS.$list.removeClass('loading');
        });
    }

    function renderList(items) {
        return new Promise(function(resolve) {
            var promises;

            STATUS.$list.empty();
            promises = [];

            items.forEach(item => {
                promises.push(renderItem(item));
            });

            if (promises.length === 0) {
                promises.push(renderItem(null));
            }

            Promise.all(promises).then($items => {
                $items.forEach($item => {
                    STATUS.$list.append($item);
                });
                resolve();
            });
        });
    }

    function renderItem(item) {
        return new Promise(function(resolve) {
            ScoreTrekBattle.Template.render(item ? 'league/matchdayItem' : 'league/planItemEmpty', {
                matchday: item,
                itemDate: item ? buildItemDate(item) : null
            }, true).then(itemView => {
                itemView.$view.find('[data-ref-id="default"]').remove();
                resolve(itemView.$view);
            });
        });
    }

    function buildItemDate(item) {
        var dateString;

        dateString = item.dateTimeMatchdayDate || '0000-00-00';

        return {
            dayText: dateString.substring(8, 10),
            monthShort: __i18n(`date/month/short/${dateString.substring(5, 7)}`)
        };
    }

    /**
     * Fuegt eine neu angelegte Kopie direkt hinter dem Original ein, springt
     * hin und laesst sie einmal pulsieren — sonst waere in einer Liste
     * gleichnamiger Begegnungen nicht zu sehen, welche gerade entstanden ist.
     */
    function insertMatchday(matchday, afterMatchdayId) {
        let $after;

        if (!STATUS.$list) {
            return;
        }

        $after = STATUS.$list.find(`[data-matchday-id="${afterMatchdayId}"]`);

        if ($after.length === 0) {
            updateList();
            return;
        }

        renderItem(matchday).then($item => {
            $item.hide();
            $after.after($item);
            $item.slideDown(() => {
                AnimationHandler.scrollIntoView($item).then(() => {
                    AnimationHandler.pulse($item);
                }).catch(() => {
                    AnimationHandler.pulse($item);
                });
            });
        });
    }

    ScoreTrekBattle.Event.on('matchday.created', function(matchday, afterMatchdayId) {
        insertMatchday(matchday, afterMatchdayId);
    });

    ScoreTrekBattle.Event.on('matchday.updated', function() {
        if (!STATUS.$list) {
            return;
        }

        updateList();
    });

    _this = {};

    ScoreTrekBattle.View.register('/league/plan', onViewRender, onViewLoad, onViewUpdate, onViewUnload, () => {
        return ScoreTrekBattle.Session.isBattleManager();
    });

    return _this;
})();
